import { render, staticRenderFns } from "./AISeek.vue?vue&type=template&id=b4698f60&scoped=true"
import script from "./AISeek.vue?vue&type=script&lang=js"
export * from "./AISeek.vue?vue&type=script&lang=js"
import style0 from "./AISeek.vue?vue&type=style&index=0&id=b4698f60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4698f60",
  null
  
)

export default component.exports